export {ImageComponent} from './ImageComponent';
export type {ImageComponentDefinition, IImageProps} from './Image.types';
export {ComponentDefinition} from './ImageDefinition';
export type {SchemaType} from './ImageDefinition';
export type {ImageProps} from './ImagePreviewComponent';
export {ImagePreviewComponent} from './ImagePreviewComponent';
export type {S3Media} from './Image.types';

import {Registry} from '@backstage-components/base';
import {ImageModule} from './ImageModule';
import {ComponentDefinition} from './ImageDefinition';
Registry.register(ComponentDefinition, ImageModule);
